import type { LucideIcon } from "lucide-react";
import { BookOpen, Home, Shield, Swords, Trophy, Users } from "lucide-react";

export type AppShellSection =
    | "home"
    | "play"
    | "tournaments"
    | "teams"
    | "learn"
    | "community";

export interface AppShellNavItem {
    section: AppShellSection;
    href: string;
    /** key in the `nav` message namespace */
    labelKey: string;
    icon: LucideIcon;
}

// The left-sidebar nav shared by the /turnuva and /takim sections.
export const APP_SHELL_NAV: readonly AppShellNavItem[] = [
    { section: "home", href: "/", labelKey: "anasayfa", icon: Home },
    { section: "play", href: "/oyun", labelKey: "oyna", icon: Swords },
    {
        section: "tournaments",
        href: "/turnuva",
        labelKey: "turnuvalar",
        icon: Trophy,
    },
    { section: "teams", href: "/takim", labelKey: "takimlar", icon: Shield },
    {
        section: "learn",
        href: "/seri/egitimler",
        labelKey: "learn",
        icon: BookOpen,
    },
    {
        section: "community",
        href: "/etkinlikler",
        labelKey: "community",
        icon: Users,
    },
] as const;
